import { setupWorker } from 'msw';
import { productHandlers } from './product-handlers';
import { voucherHandlers } from './voucher-handlers';

export const worker = setupWorker(...productHandlers, ...voucherHandlers);
